import { render, staticRenderFns } from "./ApplyReview.vue?vue&type=template&id=3562d60c"
import script from "./ApplyReview.vue?vue&type=script&lang=js"
export * from "./ApplyReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports